import React from 'react';
import classNames from 'classnames';
import FaqBlock from './FaqBlock';
import faq from '../../../faq';

const Faq = ({ view, changeView, faqDropdown, changeFaq }) =>  {

  const faqClass = classNames({
    'scene': true,
    'scene--faq': true,
    'scene--hidden': view !== 'faq'
  });

  const faqList = faq
    .map((q, index) =>
      <FaqBlock
        key={index}
        answer={q.answer}
        slug={q.slug}
        question={q.question}
        faqDropdown={faqDropdown}
        changeFaq={changeFaq}
    />);

  return (
    <div className={faqClass}>
        <div className="scene__content">
          <div className="scene__content-full">
              <h2 className="scene__tagline">&nbsp;&nbsp;&nbsp;FAQ&nbsp;&nbsp;&nbsp;</h2>
              <ul className="accordion -single -table">
                {faqList}
              </ul>
            </div>
        </div>
    </div>
  );
}

export default Faq;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Faq/Faq.js
 **/